// Template255: Bélgica - Día 4 Brujas continuación (Page13.jsx)
// Basílica Santa Sangre, Rozenhoedkaai, caja Iglesia/Plaza Burg, Begijnhof, Minnewater, Museos curiosos (sticker patatas).

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template255 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const basilicaTitle = page?.texts?.[1]?.content;
	const basilicaBody = page?.texts?.[2]?.content;
	const rozenTitle = page?.texts?.[3]?.content;
	const rozenBody = page?.texts?.[4]?.content;
	const cajaIglesiaBurg = page?.texts?.[5]?.content;
	const begijnhofTitle = page?.texts?.[6]?.content;
	const begijnhofBody = page?.texts?.[7]?.content;
	const minnewaterTitle = page?.texts?.[8]?.content;
	const minnewaterBody = page?.texts?.[9]?.content;
	const museosTitle = page?.texts?.[10]?.content;
	const museosBody = page?.texts?.[11]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const img1 = getImageSrc("img1");
	const img2 = getImageSrc("img2");
	const img3 = getImageSrc("img3");
	const stickerPatatas = getImageSrc("img2-sticker") || getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#D4A017";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
		marginBottom: "4px",
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 9999,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
				<Box data-block-id="text-2" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
					{/* Basílica Santa Sangre */}
					{(basilicaTitle || basilicaBody) && (
						<Box data-block-id="text-3" sx={{ width: "100%", position: "relative" }}>
							{sabiasQue[0] && (
								<Box sx={{ position: "absolute", bottom: -20, left: "30%" }}>
									<SabiasQue
										icono={sabiasQue[0].icono}
										texto={sabiasQue[0].texto}
									/>
								</Box>
							)}
							<Box
								sx={{
									padding: "12px",
									backgroundColor: "#f9ebc8",
									borderRadius: "12px",
									fontSize: 13,
									color: "#000",
								}}
							>
								{basilicaTitle && (
									<Box component="h3" sx={estiloH3}>
										{basilicaTitle}
									</Box>
								)}
								{basilicaBody && (
									<Box component="span" sx={estiloP}>
										{basilicaBody}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{/* Rozenhoedkaai */}
					{(rozenTitle || rozenBody) && (
						<Box
							data-block-id="text-4"
							sx={{
								display: "flex",
								gap: 2.5,
								alignItems: "flex-start",
								position: "relative",
							}}
						>
							{img1 && (
								<Box
									component="img"
									src={img1}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										borderRadius: "12px",
										objectFit: "cover",
									}}
								/>
							)}
							{sabiasQue[1] && (
								<Box sx={{ position: "absolute", top: 10, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[1].icono}
										texto={sabiasQue[1].texto}
									/>
								</Box>
							)}
							<Box sx={{ width: "60%", position: "relative" }}>
								{rozenTitle && (
									<Box component="h3" sx={estiloH3}>
										{rozenTitle}
									</Box>
								)}
								{rozenBody && (
									<Box component="p" sx={estiloP}>
										{rozenBody}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{/* Caja Iglesia / Plaza Burg */}
					{cajaIglesiaBurg && (
						<Box
							data-block-id="text-5"
							sx={{
								backgroundColor: "#fef9e6",
								border: "2px solid #D4A017",
								borderRadius: "12px",
								padding: "4px 16px",
								fontSize: "12px",
								color: "#444",
								textAlign: "center",
								position: "relative",
							}}
						>
							{sabiasQue[2] && (
								<Box sx={{ position: "absolute", top: -20, right: "33%" }}>
									<SabiasQue
										icono={sabiasQue[2].icono}
										texto={sabiasQue[2].texto}
									/>
								</Box>
							)}
							{sabiasQue[3] && (
								<Box sx={{ position: "absolute", top: -20, right: "45%" }}>
									<SabiasQue
										icono={sabiasQue[3].icono}
										texto={sabiasQue[3].texto}
									/>
								</Box>
							)}
							<Box
								component="p"
								sx={{ ...estiloP, fontSize: 13, padding: "12px" }}
								dangerouslySetInnerHTML={{ __html: cajaIglesiaBurg }}
							/>
						</Box>
					)}

					{/* Begijnhof */}
					{(begijnhofTitle || begijnhofBody) && (
						<Box data-block-id="text-6" sx={{ display: "flex", gap: 2 }}>
							{img2 && (
								<Box
									component="img"
									src={img2}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							<Box sx={{ width: "60%" }}>
								{begijnhofTitle && (
									<Box component="h3" sx={estiloH3}>
										{begijnhofTitle}
									</Box>
								)}
								{begijnhofBody && (
									<Box component="p" sx={estiloP}>
										{begijnhofBody}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{/* Minnewater */}
					{(minnewaterTitle || minnewaterBody) && (
						<Box data-block-id="text-7" sx={{ display: "flex", gap: 2, position: "relative" }}>
							{img3 && (
								<Box
									component="img"
									src={img3}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							{sabiasQue[4] && (
								<Box sx={{ position: "absolute", top: 40, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[4].icono}
										texto={sabiasQue[4].texto}
									/>
								</Box>
							)}
							<Box sx={{ width: "60%" }}>
								{minnewaterTitle && (
									<Box component="h3" sx={estiloH3}>
										{minnewaterTitle}
									</Box>
								)}
								{minnewaterBody && (
									<Box component="p" sx={estiloP}>
										{minnewaterBody}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{/* Museos curiosos */}
					{(museosTitle || museosBody) && (
						<Box
							data-block-id="text-8"
							sx={{
								display: "flex",
								gap: 2,
								position: "relative",
								marginTop: isSmallScreen ? "40px" : 0,
							}}
						>
							{stickerPatatas && (
								<Box
									component="img"
									src={stickerPatatas}
									alt=""
									sx={{
										width: 110,
										position: "absolute",
										top: -80,
										right: -10,
										zIndex: 2,
									}}
								/>
							)}
							<Box sx={{ width: "100%", position: "relative" }}>
								{sabiasQue[5] && (
									<Box sx={{ position: "absolute", top: 0, right: "35%" }}>
										<SabiasQue
											icono={sabiasQue[5].icono}
											texto={sabiasQue[5].texto}
										/>
									</Box>
								)}
								<Box
									sx={{
										padding: "16px",
										backgroundColor: "#f9ebc8",
										borderRadius: "12px",
										fontSize: 13,
										color: "#000",
									}}
								>
									{museosTitle && (
										<Box component="h3" sx={estiloH3}>
											{museosTitle}
										</Box>
									)}
									{museosBody && (
										<Box component="span" sx={estiloP}>
											{museosBody}
										</Box>
									)}
								</Box>
							</Box>
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template255.thumbnail = "/images/template-1.png";
export default Template255;
